import { useEffect, useState } from 'react';
import usePost from './usePost';

const useUploadFile = (allowTypes = '', path = '', type = 'file') => {
  const [location, setLocation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const {
    data: resultUploads,
    loading: loadingUpload,
    error: uploadError,
    postData: upload,
  } = usePost(false);
  const { data: resultdelete, loading: loadingDeleting, postData: deleteItem } = usePost(false);

  const [isMulti, setIsMulti] = useState(false);
  const [multiFileLength, setMultiFileLength] = useState(0);
  const [tempLocations, setTempLocations] = useState([]);

  const extractUploadedLocation = (payload) => {
    const direct =
      payload?.data?.location ??
      payload?.data?.Location ??
      payload?.location ??
      payload?.Location ??
      payload?.url ??
      payload?.data?.url;

    return typeof direct === 'string' ? direct.trim() : '';
  };

  const handleDelete = (keyFile) => {
    const _data = { keyFile };
    deleteItem(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/delete`, _data);
  };

  const renameFile = (file, index = 0) => {
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (!ext) {
      alert('❌ ملف بدون امتداد! يرجى اختيار ملف صحيح.');
      return null;
    }
    const cleanExt = ext.replace(/[^a-z0-9]/gi, '');
    const newName = `upload_${Date.now()}_${index}.${cleanExt}`;
    return new File([file], newName, { type: file.type });
  };

  const isAllowedType = (fileType) => {
    if (allowTypes == null) return true;
    if (Array.isArray(allowTypes)) return allowTypes.length === 0 || allowTypes.includes(fileType);
    if (typeof allowTypes === 'string') {
      const normalized = allowTypes.trim();
      if (!normalized) return true;
      if (normalized === '*' || normalized === '*/*') return true;
      const parts = normalized.split(',').map((p) => p.trim()).filter(Boolean);
      return parts.length === 0 || parts.includes(fileType);
    }
    return true;
  }

  const handleUpload = async (event) => {
    setIsMulti(false);
    setLoading(true);
    const file = event.target.files[0] || null;

    if (file) {
      const renamedFile = renameFile(file);
      if (!renamedFile) {
        setLoading(false);
        return;
      }

      if (isAllowedType(renamedFile.type)) {
        try {
          const _formData = new FormData();
          _formData.append('myfile', renamedFile, renamedFile.name);
          upload(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/${path}`, _formData);
        } catch (error) {
          setLoading(false);
          console.error('Error uploading file:', error);
        }
      } else {
        setLoading(false);
        alert(`❌ نوع الملف غير مدعوم: ${renamedFile.type}`);
        console.log('error image type:', renamedFile.type);
      }
      return;
    }
    setLoading(false);
  };

  const handleMultiUploads = async (event) => {
    setIsMulti(true);
    const files = Object.values(event.target.files || {});
    setTempLocations([]);

    const prepared = files
      .map((file, index) => renameFile(file, index))
      .filter(Boolean)
      .filter((file) => {
        const ok = isAllowedType(file.type);
        if (!ok) {
          alert(`❌ نوع الملف غير مدعوم: ${file.type}`);
        }
        return ok;
      });

    setMultiFileLength(prepared.length);

    if (prepared.length === 0) {
      setLoading(false);
      return;
    }

    setLoading(true);

    prepared.forEach((file) => {
      try {
        const _formData = new FormData();
        _formData.append('myfile', file, file.name);
        upload(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/${path}`, _formData);
      } catch (error) {
        setError(error);
        setMultiFileLength((prev) => Math.max(0, prev - 1));
      }
    });
  };

  useEffect(() => {
    if (resultUploads) {
      const uploadedLocation = extractUploadedLocation(resultUploads);

      if (!uploadedLocation) {
        setError(resultUploads);
        if (!isMulti) {
          setLoading(false);
        } else {
          setMultiFileLength((prev) => Math.max(0, prev - 1));
        }
        return;
      }

      if (!isMulti) {
        setLocation(uploadedLocation);
        setLoading(false);
      } else {
        setTempLocations((prev) => [...prev, uploadedLocation]);
        setMultiFileLength((prev) => Math.max(0, prev - 1));
      }
    }
  }, [resultUploads]);

  useEffect(() => {
    if (!uploadError) return;
    setError(uploadError);
    if (!isMulti) {
      setLoading(false);
      return;
    }
    setMultiFileLength((prev) => Math.max(0, prev - 1));
  }, [uploadError, isMulti]);

  useEffect(() => {
    if (!isMulti || multiFileLength !== 0) return;
    if (tempLocations.length > 0) {
      setLocation(tempLocations.join(','));
    }
    setLoading(false);
  }, [multiFileLength, isMulti, tempLocations]);

  return {
    location,
    loading,
    error,
    handleUpload,
    handleMultiUploads,
    resultdelete,
    loadingDeleting,
    handleDelete,
  };
};

export default useUploadFile;
